import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import PrivacyPolicy from "./component/policies/PrivacyPolicy";
import Home from "./component/Home";
import TermsConditions from "./component/TermsConditions";
// import AccountDeletionPolicy from "./component/policies/AccountDeletionPolicy";
import FairPracticeCode from "./component/FairPracticeCode";
import GrievanceRedressalPolicy from "./component/GrievanceRedressalPolicy";
import ContactUs from "./component/ContactUs";
import ApplyNow from "./component/ApplyNow";
import FraudTicker from "./component/FraudTicker";

// Lazy so framer-motion (chatbot-only) stays out of the initial bundle.
const ChatBot = lazy(() => import("./component/ChatBot"));



function App() {
  return (
    <>
    <Routes>
        <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          {/* The app's Terms links (set in the CRM) use this spelling. */}
          <Route path="/terms-condition" element={<Navigate to="/terms-conditions" replace />} />
          <Route path="/apply-now" element={<ApplyNow />} />
          {/* <Route path="/account-delete-policy" element={<AccountDeletionPolicy />} /> */}
          <Route path="/fair-practice-code" element={<FairPracticeCode />} />
          <Route path="/grievance-redressal-policy" element={<GrievanceRedressalPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />

      </Routes>
      <FraudTicker />
      <Suspense fallback={null}>
        <ChatBot />
      </Suspense>
    </>
  );
}

export default App;
